/****Global Variables****/
var smallScreen = jQuery(window).width() < 481 ? true : false;
var shortScreen = jQuery(window).height() < 460 ? true : false;
var ci_language = "";
var ci_languages = {
  english: ".lang-en",
  spanish: ".lang-es",
};
var ci_language_opposites = {
  english: "spanish",
  spanish: "english",
};

var ci_language_codes = {
  english: "en",
  spanish: "es",
};

/**** Toggles English/Spanish language.****/
// Handles initial language switch on page load.
function loadLanguage($) {
  if (docCookies?.hasItem("ci_language")) {
    ci_language = docCookies.getItem("ci_language");
  } else if (window.navigator.language.substring(0, 2) == "es") {
    ci_language = "spanish";
    ci_progress("language", "load", ci_language);
  } else if (location.search.indexOf("lang=es") == 1) {
    ci_language = "spanish";
    ci_progress("language", "link", ci_language);
    docCookies.setItem("ci_language", ci_language);
  } else {
    ci_language = "english";
  }

  jQuery(ci_languages[ci_language_opposites[ci_language]]).addClass(
    "hidden-lang"
  );
  $(ci_languages[ci_language]).addClass("active-lang");
  $("svg " + ci_languages[ci_language]).attr(
    "class",
    "lang-" + ci_language_codes[ci_language] + " active-lang"
  );
}

// Handles toggling of languages.
function toggleLanguage() {
  jQuery("body").data("lang-transitioning", "true");
  jQuery("svg .active-lang").attr(
    "class",
    "lang-" + ci_language_codes[ci_language]
  );
  jQuery(".active-lang")
    .removeClass("active-lang")
    .on(
      "transitionend.ci_lang webkitTransitionEnd.ci_lang oTransitionEnd.ci_lang",
      function (event) {
        if (jQuery("body").data("lang-transitioning") == "true") {
          jQuery("body").data("lang-transitioning", "false");
          jQuery(ci_languages[ci_language_opposites[ci_language]]).addClass(
            "hidden-lang"
          );
          jQuery(
            "svg " + ci_languages[ci_language_opposites[ci_language]]
          ).attr(
            "class",
            "lang-" +
              ci_language_codes[ci_language_opposites[ci_language]] +
              " hidden-lang"
          );
          // Removes event handlers for transitionEnd.
          jQuery(".hidden-lang").off(".ci_lang");
        }
      }
    );

  switch (ci_language) {
    case "english":
      ci_language = "spanish";
      break;
    case "spanish":
      ci_language = "english";
      break;
  }

  ci_progress("language", "toggle", ci_language);
  window.setTimeout(
    'jQuery(ci_languages[ci_language]).removeClass("hidden-lang").addClass("active-lang")',
    500
  );

  window.setTimeout(
    'jQuery("svg " + ci_languages[ci_language]).attr("class", ci_languages[ci_language] + " active-lang")',
    500
  );

  docCookies.removeItem("ci_language");
  docCookies.setItem("ci_language", ci_language);
  jQuery("body").trigger("ci_language_toggle");
}

function isLandscape() {
  return jQuery(window).height() < jQuery(window).width();
}

jQuery(document).ready(function ($) {
  jQuery("header#navbar").autoHidingNavbar();
  jQuery("a.external").on("click.external", function () {
    var hrefURI = "";
    if (typeof this.href == "string") {
      hrefURI = this.href;
    } else {
      hrefURI = getAttributeNS("http://www.w3.org/1999/xlink", "href");
    }

    if (jQuery(this).hasClass("social")) {
      window.open(hrefURI, "", "width=500,height=400");
    } else {
      window.open(hrefURI);
    }
    return false;
  });

  loadLanguage($);

  jQuery("#menu-button").on("click", function () {
    jQuery("#menu-button").toggleClass("collapsed");
    jQuery("body").toggleClass("menu-open");
    jQuery(".reveal").toggleClass("net");

    // JavaScript-based width transition
    var $hidebar = jQuery('.hidebar');
    if ($hidebar.length) {
      var isShown = $hidebar.hasClass('show');

      if (isShown) {
        // Hide menu with smooth transition
        $hidebar.removeClass('show').animate({
          width: '0'
        }, {
          duration: 500,
          easing: 'easeInOutQuad',
          step: function(now) {
            // Ensure overflow is hidden during animation
            if (now < 50) {
              $hidebar.css('overflow', 'hidden');
            }
          },
          complete: function() {
            // Keep overflow hidden when fully collapsed
            $hidebar.css('overflow', 'hidden');
          }
        });
      } else {
        // Show menu with smooth transition
        $hidebar.addClass('show').animate({
          width: '190px'
        }, {
          duration: 500,
          easing: 'easeInOutQuad',
        });
      }
    }
  });

  jQuery(".language-toggle").on("click.toggle", function () {
    toggleLanguage();
  });

  jQuery(".reveal").on("click", function () {
    jQuery("#menu-button").click();
  });

  // Expands clicked nested elements.
  jQuery(".leading-question").each(function (i, q) {
    jQuery(q).on("click", function () {
      jQuery(this)
        .find("p")
        .each(function (i, p) {
          jQuery(p).toggleClass("open");
        });
    });
  });

  var ci_subscribe_en = jQuery("#ci_subscribe_en").detach();
  var ci_subscribe_es = jQuery("#ci_subscribe_es").detach();

  jQuery("#subscribe_en").on("click", function () {
    jQuery.colorbox({
      html: ci_subscribe_en.html(),
      className: "subscribe",
      height: "90%",
    });
    return false;
  });

  jQuery("#subscribe_es").on("click", function () {
    jQuery.colorbox({
      html: ci_subscribe_es.html(),
      className: "subscribe",
      height: "90%",
    });
    return false;
  });

  jQuery(document)
    .on("cbox_open", function () {
      jQuery("body").css({ overflow: "hidden" });
    })
    .on("cbox_closed", function () {
      jQuery("body").css({ overflow: "" });
    });
});

jQuery(window).on("load", function () {
  if (jQuery(".a404error").length) {
    prep404();
  }
});

function prepLinks() {
  jQuery("#colorbox a.external").on("click.external", function () {
    window.open(this.href);
    return false;
  });
}
function unLink() {
  jQuery("#colorbox a.external").off("click.external");
}

jQuery(document).on("ready", function () {
  TweenLite.to(".reveal", 0.5, { opacity: 0, display: "none", delay: 0.25 });

  // Open social media links in new smaller window.
  jQuery("#share_graphic a").on("click", function (e) {
    e.preventDefault();
    var posX = screen.width / 2 - 250;
    var posY = screen.height / 2 - 150;
    window.open(
      $(this).attr("href"),
      "",
      "menubar=no, toolbar=no, width=500, height=300, top=" +
        posY +
        " left=" +
        posX
    );
  });
});

jQuery(window).on("onbeforeunload", function () {
  jQuery(".reveal").addClass("obscure");
  TweenLite.to(".reveal", 0.25, { display: "block", opacity: 1 });
});

function setHeader(headerPosition) {
  // Receives text: "hide" or "show".
  jQuery("header#navbar").autoHidingNavbar(headerPosition);
}

function capitalize(words) {
  var returnValue = "";
  var vocabulary = words.split(" ");
  vocabulary.forEach(function (word, i, arr) {
    arr[i] = word.toString().charAt(0).toUpperCase() + word.slice(1);
  });
  return vocabulary.join(" ");
}

// GA events integration.
function ci_progress(c, a, l) {
  try {
    ga("send", {
      hitType: "event",
      eventCategory: l,
      eventAction: a,
      eventLabel: l,
      page: location.href,
    });
  } catch (e) {}
}

// 404 page animation.
function prep404() {
  var jitter = new TimelineMax({ repeat: 2, delay: 1.8 });
  TweenLite.from(".a404error", 0.5, { y: "-500px", delay: 0.5 });
  TweenLite.to(".a404error", 0, { display: "block", delay: 0.5 });
  TweenLite.from("#a404", 0.25, { y: 300, delay: 1.25 });
  TweenLite.from("#a404oh", 0.25, { x: 500, delay: 1.5 });
  TweenLite.from("#a404no", 0.25, { x: 500, delay: 1.6 });
  TweenLite.from("#a404text", 0.25, { y: 300, delay: 1.75 });
  TweenLite.from("#a404home", 0.25, { y: 300, delay: 1.75 });
  jitter.to(".a404ah", 0.1, { x: "5", ease: Elastic.easeOut });
  jitter.to(".a404ah", 0.1, { x: "0", ease: Elastic.easeOut });
}

// Adds bind() function for javascript versions older than 1.8.5.
if (!Function.prototype.bind) {
  Function.prototype.bind = function (oThis) {
    if (typeof this !== "function") {
      // closest thing possible to the ECMAScript 5 internal IsCallable function
      throw new TypeError(
        "Function.prototype.bind - what is trying to be bound is not callable"
      );
    }

    var aArgs = Array.prototype.slice.call(arguments, 1),
      fToBind = this,
      fNOP = function () {},
      fBound = function () {
        return fToBind.apply(
          this instanceof fNOP && oThis ? this : oThis,
          aArgs.concat(Array.prototype.slice.call(arguments))
        );
      };

    fNOP.prototype = this.prototype;
    fBound.prototype = new fNOP();

    return fBound;
  };
}

/*\
|*|
|*|  :: cookies.js ::
|*|
|*|  A complete cookies reader/writer framework with full unicode support.
|*|
|*|  Revision #1 - September 4, 2014
|*|
|*|  https://developer.mozilla.org/en-US/docs/Web/API/document.cookie
|*|  https://developer.mozilla.org/User:fusionchess
|*|
|*|  This framework is released under the GNU Public License, version 3 or later.
|*|  http://www.gnu.org/licenses/gpl-3.0-standalone.html
|*|
|*|  Syntaxes:
|*|
|*|  * docCookies.setItem(name, value[, end[, path[, domain[, secure]]]])
|*|  * docCookies.getItem(name)
|*|  * docCookies.removeItem(name[, path[, domain]])
|*|  * docCookies.hasItem(name)
|*|  * docCookies.keys()
|*|
\*/

var docCookies = {
  getItem: function (sKey) {
    if (!sKey) {
      return null;
    }
    return (
      decodeURIComponent(
        document.cookie.replace(
          new RegExp(
            "(?:(?:^|.*;)\\s*" +
              encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") +
              "\\s*\\=\\s*([^;]*).*$)|^.*$"
          ),
          "$1"
        )
      ) || null
    );
  },
  setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }
    var sExpires = "";
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires =
            vEnd === Infinity
              ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT"
              : "; max-age=" + vEnd;
          break;
        case String:
          sExpires = "; expires=" + vEnd;
          break;
        case Date:
          sExpires = "; expires=" + vEnd.toUTCString();
          break;
      }
    }
    document.cookie =
      encodeURIComponent(sKey) +
      "=" +
      encodeURIComponent(sValue) +
      sExpires +
      (sDomain ? "; domain=" + sDomain : "") +
      (sPath ? "; path=" + sPath : "") +
      (bSecure ? "; secure" : "");
    return true;
  },
  removeItem: function (sKey, sPath, sDomain) {
    if (!this.hasItem(sKey)) {
      return false;
    }
    document.cookie =
      encodeURIComponent(sKey) +
      "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" +
      (sDomain ? "; domain=" + sDomain : "") +
      (sPath ? "; path=" + sPath : "");
    return true;
  },
  hasItem: function (sKey) {
    if (!sKey) {
      return false;
    }
    return new RegExp(
      "(?:^|;\\s*)" +
        encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") +
        "\\s*\\="
    ).test(document.cookie);
  },
  keys: function () {
    var aKeys = document.cookie
      .replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "")
      .split(/\s*(?:\=[^;]*)?;\s*/);
    for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
    }
    return aKeys;
  },
};
